import AxiosCustom from "../../../common/components/apiConfig";

export const delete_offline_order = (data) => {
  let config = { url: "update_request" };

  let _data = {
    table: "offlineorder",
    method_type: "update_offline_order",
    data: {
      ...data,
    },
  };

  return AxiosCustom(config, _data);
};
